import { array, required, obj, optional } from 'AppReact/schema';
import { event } from './event'

export const checklistItem = {
  name: required('string'),
  description: required('string'),
  id: required('integer'),
  admin_id: optional('integer'),
  admin_logo: optional('string'),
  assigned_to: optional('string'),
  due_date: optional('jsDate'),
  checklist_id: required('integer'),
  request_id: required('integer'),
  is_complete: required('boolean'),
  events: array(obj(event)),
}